var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"86vh"}},[_c('Sidebar',{ref:"sidebar",attrs:{"list":_vm.treeData}}),_c('el-container',[_c('el-main',[_c('appMain')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }